import {
  useContext, useEffect, useRef, useState,
} from 'react';

import ApiImportIcon from 'assets/icons/apiImport.svg';
import CsvImportIcon from 'assets/icons/csvImport.svg';
import { CtPlatform, CtPlatformImportType } from 'models/general';
import {
  StoreContext, ImportSectionEnum,
} from 'models/import';
import Card, { CardItem } from 'components/card';

function ImportPlatformCardsComponent() {
  const [cardItems, setCardItems] = useState([] as CardItem[]);
  const ref = useRef<HTMLDivElement>(null);

  const {
    platform, setActiveSection, setImportType,
  } = useContext(StoreContext);

  const mapCardItems = (p?: CtPlatform): CardItem[] => {
    if (!(p && p.supported_import_types)) return [];

    const types = p.supported_import_types;
    const recommended = p.recommended_import_type;

    return Object.entries(types)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([key, value]) => value)
      .map(([type]) => {
        if (type === 'api') {
          return {
            icon: <ApiImportIcon />,
            title: 'Api Sync',
            desc: `Import your ${p.display_name || ''} trades automatically`,
            isRecommended: recommended === type,
            type,
          } as CardItem;
        }

        if (type === 'csv') {
          return {
            icon: <CsvImportIcon />,
            title: 'CSV Upload',
            desc: `Export a CSV from ${p.display_name || ''} and upload it into CoinTracking`,
            isRecommended: recommended === type,
            type,
          } as CardItem;
        }

        return {};
      });
  };

  const selectCard = (type: CtPlatformImportType) => {
    setImportType({ data: type });
    setActiveSection({ data: ImportSectionEnum.OPTIONS, ref: undefined });
  };

  useEffect(() => {
    const items = mapCardItems(platform);
    if (items) {
      setCardItems(items);
    }
    setActiveSection({
      data: ImportSectionEnum.CARDS,
      ref: ref && ref.current,
      instructions: platform && platform.import_instructions,
    });
  }, [platform]);

  if (!cardItems) return null;

  return (
    <div ref={ref}>
      <Card
        items={cardItems}
        onClick={(item: CardItem) => selectCard(item.type as CtPlatformImportType)}
      />
    </div>
  );
}

export default ImportPlatformCardsComponent;
